import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { Outlet, RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import Platforms from 'src/content/applications/OTT-Statistics/platforms';
import Drm_conditional from './content/applications/OTT-Reports/Drm_conditional_Reports';
import DrmFingerprinting from './content/applications/OTT-Reports/Drm_Fingerprint';
import DrmStbManagement from './content/applications/OTT-Reports/Drm_Stb_Requirements';

import UniqueActivateSubscriberStbReports from './content/applications/OTT-Reports/UniqueActivateSubscriberStbReports';
import Dashboard from './content/applications/Roles/Dashboard/Dashboard';
import SubscriberDetailReport from './content/applications/OTT-Reports/SubscriptiondetailsReport';

import Stb_Reconciliation from './content/applications/OTT-Reconciliation/OTT-STB_Reconciliation';
import Package_Channel_Reconciliation from './content/applications/OTT-Reconciliation/OTT-Package_Channel_Reconciliation';
import Create_Reconciliation from './content/applications/OTT-Reconciliation/OTT-Create_Reconcilation';
import Package_Channel_Reconciliation_Data from './content/applications/OTT-Reconciliation/OTT-Package_Channel_Reconciliation_Data';
import Stb_Reconciliation_Data from './content/applications/OTT-Reconciliation/OTT-STB_Reconcilation_Data';
import Schedules from './content/applications/Schedulings';
import UserSubscriptionLogs from './content/applications/OTT-Reports/UserSubscriptionLogs';
import Forbidden from './content/pages/Forbidden';
import ProtectedRoute from './components/Permissions/ProtectedRoute';

import FingerPrintLogs from './content/applications/OTT-Reports/FingerPrintLogs';
import KeysLogs from './content/applications/OTT-Reports/KeysLogs';
import CustomeChannelReport from './content/applications/OTT-Reports/CustomeChannelReport';
import AddFranchisee from './content/applications/Franchise/AddFranchisee';
import EditFranchisee from './content/applications/Franchise/EditFranchisee';
import Role from './content/applications/Role/Role';
import AddRole from './content/applications/Role/AddRole';
import EditRole from './content/applications/Role/EditRole';
import MenusRole from './content/applications/Role/MenusRole';
import CompanyScreen from './content/applications/Company';
import OperatorScreen from './content/applications/Operator';
import AddOperator from './content/applications/Operator/AddOperator';
import EditOperator from './content/applications/Operator/EditOperator';
import LogonFranchisee from './content/applications/Franchise/LogonFranchisee';

// Add Modules import
import Modules from './content/applications/Module/Modules/index' // You'll need to create this component
import ModulePermissions from './content/applications/Module/Module-Permissions';
import ApplicationModules from './content/applications/Module/Application-Modules';
import ApplicationConfig from './content/applications/ApplicationConfig/ApplicationConfig';
import VendorDetails from './content/applications/vendors/VendorDetails';
import Addvendor from './content/applications/vendors/Addvendor';
import Updatevendor from './content/applications/vendors/Updatevendor';
import FranchiseDashboard from './content/applications/OTT-Dashboard/FranchiseDashboard';
import Resetpassword from './content/applications/ResetPassword/Resetpassword';
import AddCompany from './content/applications/Company/AddCompany';
import Updatecompany from './content/applications/Company/Updatecompany';

// import AddFranchisePayment from './content/applications/OTT-Payments/AddFranchisePayment';
// import AddFranchisePayment from './content/applications/OTT-Payments/AddFranchisePayment';
//import PolicyEditor from './content/applications/ApplicationConfig/ApplicationConfig';
//import ApplicationConfig from './content/applications/ApplicationConfig/ApplicationConfig';

import AddFranchisePayment from './content/applications/OTT-Franchise Payments/AddFranchisePayment';
import AddOnlineFranchisePayment from './content/applications/OTT-Franchise Payments/AddOnlineFranchisePayment';
import OTTFranchisePayments from './content/applications/OTT-Franchise Payments';
import AddOwner from './content/applications/Module/OwnerAccounts/AddOwner';
import UpdateOwnerAccount from './content/applications/Module/OwnerAccounts/UpdateOwnerAccount';
import ThirdAppPartyApps from './content/applications/ThirdPartyApplications';
import WatchoDetails from './content/applications/Watcho/WatchoDetails';
import PaymentTransfer from './content/applications/PaymentTransferHistory/PaymentTransfer';
import PaymentHistoryList from './content/applications/PaymentTransferHistory/PaymentHistoryList';
import BroadcasterReports from './content/applications/OTT-Reports/BroadcasterReports';
import PackageWiseAgeingReport from './content/applications/OTT-Reports/PackageWiseAgeingReport/index';
import OtaLogReport from './content/applications/OTT-Reports/OtaLogReport';

import SubscriberPackagesDetails from './content/applications/OTT-Reports/SubscriberPackagesDetails';
import Invoice from './content/applications/OTT-Users/OTT-Subscriber-Hardware-And-Channel/Invoice';

import Tax from './content/applications/OTT-Manage Tax/Tax';
import Manage_Billing_Tax from './content/applications/OTT-Manage Tax/Manage_Billing_Tax';
import RedirectionsLogs from './content/applications/OTT-Reports/RedireactionsLogs';
import TokenBasedReport from './content/applications/OTT-Reports/TokenBasedReports';
import SubscriberRegistrationStats from './content/applications/OTT-Users/RegistrationsStats';
import Multiplesubscriptions from './content/applications/OTT-Users/MultipleSubscriptions';
import Blockedsubscribers from './content/applications/OTT-Users/Blockedsubscribers';
import PriceChangeHistory from './content/applications/OTT-Reports/PriceChangeHistory';
import RefundPaymentReport from './content/applications/OTT-Reports/RefundPaymentReports';
import ImportsDataFiles from './content/applications/ImportsDataFiles';
import Servers from './content/applications/OTT-Server/Servers';
import CommissionWalletTransactions from './content/applications/CommssionTranctionsLogs';
import SubscriberMonthlyStatusReport from './content/applications/OTT-Reports/SubscriberMonthlyStatusReport';
import UserActivityLogs from 'src/content/applications/OTT-Reports/UserActivityLogs/index';

// import VersionList from 'src/layouts/SidebarLayout/Header/Buttons/crmVersionController/VersionList';















const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Pages
const ExpiredSubcriptionList = Loader(lazy(()=> import('src/content/applications/OTT-Users/ExpiredSubcriptionList'))) ;
const SubscribersTickets = Loader(lazy(()=> import('src/content/applications/CustomerTickets/SubscribersTickets'))) ;
const Fingerprints = Loader(lazy(()=> import('src/content/applications/AllFingerPrints/Fingerprints'))) ;
const Watcho = Loader(lazy(()=> import('src/content/applications/Watcho/watcho'))) ;
const Paymentgatwaylist = Loader(lazy(()=> import('src/content/applications/Paymentgatway'))) ;
const PaymentSuccess = Loader(lazy(()=> import('src/content/pages/PaymentStatus/PaymentSuccess'))) ;
const PaymentFailed = Loader(lazy(()=> import('src/content/pages/PaymentStatus/PaymentFailure'))) ;
const ThirdPartyApps = Loader(lazy(()=> import('src/content/applications/Module/ThirdPartyApplication/Index'))) ;
const OnBoardFranchiseLocations = Loader(lazy(()=> import('src/content/applications/Module/Locations'))) ;
const FranchiseLocations = Loader(lazy(()=> import('src/content/applications/FranchiseLocations'))) ;
const OwnerAccountList = Loader(lazy(()=> import('src/content/applications/Module/OwnerAccounts'))) ;
const Overview = Loader(lazy(() => import('src/content/overview')));
const OTASCREEN = Loader(lazy(() => import('src/layouts/SidebarLayout/Header/Buttons/OTA')));
const CreateOTA = Loader(lazy(() => import('src/layouts/SidebarLayout/Header/Buttons/OTA/CreateOTA')));
const VersionList = Loader(lazy(() => import('src/layouts/SidebarLayout/Header/Buttons/CrmVersonControlls/VersionList')));



// Dashboards
const Tasks = Loader(lazy(() => import('src/content/dashboards/Tasks')));
const AreaPriceList = Loader(lazy(()=>import('src/content/applications/AreaPriceList')))
const AddPriceList = Loader(lazy(()=>import('src/content/applications/AreaPriceList/AddPriceList')))
const UpdateAreaPrice = Loader(lazy(()=>import('src/content/applications/AreaPriceList/UpdateAreaPrice')))
// Application Components
const Login = Loader(lazy(() => import('src/content/applications/Login')));
const OTTUser = Loader(lazy(() => import('src/content/applications/OTT-Users')));
const OTTChannels = Loader(lazy(() => import('src/content/applications/OTT-Channels/channels')));
const OTTChannelCategory = Loader(lazy(() => import('src/content/applications/OTT-Channels/category')));
const Advertisement = Loader(lazy(() => import('src/content/applications/Advertisement')));
const OTTDashboard = Loader(lazy(() => import('src/content/applications/OTT-Dashboard')));
const OTTPackage = Loader(lazy(() => import('src/content/applications/OTT-Packages')));
const OTTPackagePricing = Loader(lazy(() => import('src/content/applications/OTT-Packages')));
const OTTPackageChannelMapping = Loader(lazy(() => import('src/content/applications/OTT-Packages/OTT-Mapping')));
const OTTVODListing = Loader(lazy(() => import('src/content/applications/OTT-VOD')));
const OTTSubscritions = Loader(lazy(() => import('src/content/applications/OTT-Subscriptions')));
const Payments = Loader(lazy(() => import('src/content/applications/Payments')));
const OTTAudioListing = Loader(lazy(() => import('src/content/applications/OTT-Audio')));

// const BrodCast = Loader(lazy(() => import('src/content/applications/BrodCast')));
//Theme
const OTTFingerprint = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/index')));
// const OTTFingerprintCASAlerts = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/casAlerts/index')));
// const OTTFingerprintOSD = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/KingVonOSD/index')));
// const OTTFingerprintEmail = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/Email')));
const OTTFingerprintGlobalFingerprint = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/GlobalFingerprint/index')));
const OTTFingerprintChannelFingerprint = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/ChannelFingerPrint/index')));
const OTTForensicFingerprintScreen = Loader(lazy(() => import('src/content/applications/OTT-Fingerprint/ForensicFingerprint/index')));

const Franchise = Loader(lazy(() => import('src/content/applications/Franchise/index')));



const OTTEmail = Loader(lazy(() => import('src/content/applications/OTT-Email/index')));
const OTTPayments = Loader(lazy(() => import('src/content/applications/OTT-Payments/index')));
const OTTUserPanel = Loader(lazy(() => import('src/content/applications/OTT-User Panel')));
const OTTContentPanel = Loader(lazy(() => import('src/content/applications/OTT-Content Panel')));

const OTTServersPanel = Loader(lazy(() => import('src/content/applications/OTT-Server Panel')));

const OTTReports = Loader(lazy(() => import('src/content/applications/OTT-Reports')));
const OTTChannelStatusReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/ChannelStatusReport/index')));
const OTTDRMEventsReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/DRMEventsReport/index')));
const OTTSubscriptionReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/SubscriptionReport/index')));
//const OTTAuditLogsReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/AuditLogsReport/index')));
const OTTSTBActivationHistoryReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/STBActivationHistoryReport/index')));
const OTTChannelActivationDeactivationHistoryReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/ChannelActivationDeactivationReport/index')));
const OTTChannelAgeingReports = Loader(lazy(() => import('src/content/applications/OTT-Reports/ChannelAgeingReport/index')));
const PackageActivationReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/PackageReport/index')));
const MonthlySubscriptionPackReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/MonthlySubscriptionPackReport/index')));
const AlaCarteChannelMapReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/AlaCarteChannelMapReport/index')));
const PackageWiseSTBCountReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/SMSPackageWiseUniqueActiveSTBCount/index')));

const PackageChannelCompositionLogReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/PackageChannelCompositionLogReport/index')));
const PackageChannelModificationLogReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/PackageChannelModificationLogReport/index')));
const SubscriberHardwareAndChannel = Loader(lazy(() => import('src/content/applications/OTT-Users/OTT-Subscriber-Hardware-And-Channel/index')));
const Multiplesubscription = Loader(lazy(() => import('src/content/applications/OTT-Users/multySubscribers/index')));
const SubscriberDetailLogReport = Loader(lazy(() => import('src/content/applications/OTT-Reports/SubscriberDetailLogReport/index')));

const Permissions = Loader(lazy(() => import('src/content/applications/Module/Permissions/index')));


const OTTStatistics = Loader(lazy(() => import('src/content/applications/OTT-Statistics')));
const OTTStatisticsPanel = Loader(lazy(() => import('src/content/applications/OTT-Statistics Panel')));
const Maps = Loader(lazy(() => import('src/content/applications/OTT-Statistics/Map')));
const platforms = Loader(lazy(() => import('src/content/applications/OTT-Statistics/platforms')));
const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);
// Common Components Examples
const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

// Global Status Modules
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Login />
      },
      {
        path: 'login',
        element: <Navigate to="/" replace />
      },
      {
        path: 'logon-franchisee',
        element: <LogonFranchisee/>
      },

      // { path: 'unauthorized', element: <Unauthorized /> },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },

  //OTT Starts
  {
    path: 'ott',
    element: <SidebarLayout />,
    children: [
      {
        path: 'dashboard',
        element: <OTTDashboard />
      },
      {
        path: 'franchise-dashboard',
        element: <FranchiseDashboard />
      }
    ]
  },

  {
    path: 'importDataFiles',
    element: <SidebarLayout />,
    children: [
      {
        path: 'imports',
        element: <ImportsDataFiles />
      }
    ]
  },

  ,

  {
    path: 'Resetpassword',
    element: <SidebarLayout />,
    children: [
      {
        path: 'Resetpassword',
        element: <Resetpassword />
      }
    ]
  },

  // {
  //   path: 'ott',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: 'dashboard',
  //      element: (
  //         <ProtectedRoute
  //           element={<OTTDashboard />}
  //           allowedRoles={[
  //             'OWNER', 
  //             "dashboard.index", 
  //             "dashboard.create", 
  //             "dashboard.edit", 
  //             "dashboard.delete"
  //           ]}
  //         />
  //       )
  //     },
  //     // {
  //     //   path: 'franchise-dashboard',
  //     //   element: <FranchiseDashboard />
  //     // }
  //   ]
  // },


  // Add Modules Route
  {
    path: 'modules',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="modules" replace />
      },
      {
        path: 'modules',
        element: (
          <ProtectedRoute
            element={<Modules />}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      },
      {
        path: 'ThirdPartyApps',
        element: (
          <ProtectedRoute
            element={<ThirdPartyApps/>}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      }
      ,
      {
        path: 'OwnerAccounts',
        element: (
          <ProtectedRoute
            element={<OwnerAccountList />}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      }

      ,
      {
        path: 'UpdateOwner/:id',
        element: (
          <ProtectedRoute
            element={<UpdateOwnerAccount />}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      }
      
      
      
      
      
      ,
      
      {
        path: 'AddOwner',
        element: (
          <ProtectedRoute
            element={<AddOwner />}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      },
      
      {
        path: 'applications-modules',
        element: (
          <ProtectedRoute
            element={<ApplicationModules />}
            allowedRoles={['OWNER', 'Admin']}
          />
        )
      },
      {
      path: 'permissions-modules',
      element: (
        <ProtectedRoute
          element={<ModulePermissions />}
          allowedRoles={['OWNER', 'Admin']} 
        />
      )
    },
    {
      path: 'permissions',
      element: (
        <ProtectedRoute
          element={<Permissions />}
          allowedRoles={['OWNER', 'Admin']}  
        />
      )
    },
    {
      path: 'Locations',
      element: (
        <ProtectedRoute
          element={<OnBoardFranchiseLocations />}
          allowedRoles={['OWNER', 'Admin']}  
        />
      )
    }
    ]
  },


  {
    path: 'Thirdparty',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="modules" replace />
      },
      {
        path: 'ThirdPartyApps',
        element: (
          <ProtectedRoute
            element={<ThirdAppPartyApps/>}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  {
    path: 'ottusers',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="users" replace />
      },
      ,
      {
        path: 'ExpiredSubcriptionList',
        element: <ExpiredSubcriptionList/>
      },
      {
        path: 'users',
         element: (
          <ProtectedRoute
            element={<OTTUser />}
            allowedRoles={[
              'OWNER', 
              "subscriber.index", 
              "subscriber.create", 
              "subscriber.edit", 
              "subscriber.delete"
            ]}
          />
        )
      },
          {
            path: 'SubscribeRegistrationStatus/:status',
            element: <SubscriberRegistrationStats />
          },
      {
        path: 'subscriber-hardware-and-channel/:userId',
        element: <SubscriberHardwareAndChannel />
      },
      {
        path: 'multiplesubscription',
        element: <Multiplesubscription />
      },
      ,
      {
        path: 'invoicescreen/:orderId',
        element: <Invoice />
      },
      {
        path: 'BlockListedUsers',
        element: <Blockedsubscribers />
      }

    ]
  },
{
  path: 'Versions',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: <Navigate to="VersionList" replace />
    },
    {
      path: 'VersionList',
      element: (
        <ProtectedRoute
          element={<VersionList />}
          allowedRoles={[
            'OWNER',
            'version.index',
            'version.create',
            'version.edit',
            'version.delete'
          ]}
        />
      )
    }
  ]
},


  {
  path: 'managetax',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: <Navigate to="tax" replace />
    },
    {
      path: 'tax',
      element: (
        <ProtectedRoute
          element={<Tax />}  // You'll need to create this component
          allowedRoles={['OWNER', "tax.index", "tax.create", "tax.edit", "tax.delete"]}
        />
      )
    },
    {
      path: 'manage-billing-tax-type',
      element: (
        <ProtectedRoute
          element={<Manage_Billing_Tax />}  // You'll need to create this component
          allowedRoles={['OWNER', "billing_tax_type.index", "billing_tax_type.create", "billing_tax_type.edit", "billing_tax_type.delete"]}
        />
      )
    }
  ]
},
  {
    path: 'ottreports',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="reports" replace />
      },
      {
        path: 'reports',
        element: (
          <ProtectedRoute
            element={<OTTReports />}
            allowedRoles={['OWNER']}
          />
        )
      },
      {
        path: 'channelstatus-report',
        element: <OTTChannelStatusReports />
      },
      {
        path: 'CustomeChannel-report',
        element: <CustomeChannelReport />
      },
      {
        path: 'subscription-report',
        element: <OTTSubscriptionReports />
      },
      {
        path: 'drmevents-report',
        element: <OTTDRMEventsReports />
      },
      {
        path: 'UserActivityLogs',
        element: <UserActivityLogs />
      },
      {
        path: 'channelageing-report',
        element: <OTTChannelAgeingReports />
      },
      {
        path: 'package-wise-ageing',
        element: <PackageWiseAgeingReport />
       },
       {
        path: 'OtalogReport',
        element: <OtaLogReport />
       },
       {
        path: 'SubscriberPackageList',
        element: <SubscriberPackagesDetails />
       },
      {
        path: 'Drm_conditional_report',
        element: <Drm_conditional />
      },
      {
        path: 'DrmFingerprinting',
        element: <DrmFingerprinting />
      },
      {
        path: 'DrmStbManagement',
        element: <DrmStbManagement />
      },

       {
        path: 'packageActivationReport',
        element: <PackageActivationReport />
      },
        {
        path: 'monthlySubscriptionPackReport',
        element: <MonthlySubscriptionPackReport />
        },
      {
        path: 'UniqueActivateSubscriberStbReports',
        element: <UniqueActivateSubscriberStbReports />

      },
      {
        path: 'STBActivationHistoryReports',
        element: <OTTSTBActivationHistoryReports />

      },
      {
        path: 'SubscriberMonthlyStatusReport',
        element: <SubscriberMonthlyStatusReport />

      },
      {
        path: 'ChannelActivationDeactivationHistoryReports',
        element: <OTTChannelActivationDeactivationHistoryReports />

      },
      {
        path: 'alaCarteChannelMapReport',
        element: <AlaCarteChannelMapReport />
      }, 
      {
        path: 'packageWiseSTBCountReport',
        element: <PackageWiseSTBCountReport />
      },
      {
        path: 'BroadcasterReports',
        element: <BroadcasterReports />
      },
      {
        path: 'package-channel-composition-report',
        element: <PackageChannelCompositionLogReport />
      },
      {
        path: 'package-channel-modification-report',
        element: <PackageChannelModificationLogReport />
      },
      {
        path: 'packageactivationdetailsreport',
        element: <SubscriberDetailReport />
      }
      ,
      {
        path: 'UserSubscriptionLogs',
        element: <UserSubscriptionLogs />
      },
      {
        path: 'UserDetailLogReport',
        element: <SubscriberDetailLogReport />
      },
      {
        path: 'RefundPaymentReport',
        element: <RefundPaymentReport />
      },
      {
        path: 'FingerPrintLogs',
        element: <FingerPrintLogs />
      },
      {
        path: 'KeysLogs',
        element: <KeysLogs />
      },
      {
        path: 'RedirectionLogs',
        element: <RedirectionsLogs />
      },
      {
        path: 'TokenBasedReport',
        element: <TokenBasedReport />
      },
      {
        path: 'price-change-history',
        element: <PriceChangeHistory />
      },
    ]
  },

  {
    path: 'ottpaymentgateway',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="paymentgateway" replace />
      },
      {
        path: 'paymentgateway',
        element: (
          <ProtectedRoute
            element={<Paymentgatwaylist />}
            allowedRoles={['OWNER','paymentgateway.create',
              'paymentgateway.edit','paymentgateway.delete','paymentgateway.index']}
          />
        )
      }
    ]
  },

  {
    path: 'ottchannels',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="channels" replace />
      },
      {
        path: 'channels',
        element: (
          <ProtectedRoute
            element={<OTTChannels />}
            allowedRoles={[
              'OWNER', 
              'User',
              "channel.index", 
              "channel.create", 
              "channel.edit", 
              "channel.delete"
            ]}
          />
        )
      },
      {
        path: 'category',
        element: (
          <ProtectedRoute
            element={<OTTChannelCategory />}
            allowedRoles={[
              'OWNER', 
              'User',
              "category.index", 
              "category.create", 
              "category.edit", 
              "category.delete"
            ]}
          />
        )
      }
    ]
  },
  {
    path: 'ottpackages',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="package" replace />
      },
      {
        path: 'package',
        element: (
          <ProtectedRoute
            element={<OTTPackage />}
            allowedRoles={['OWNER', 'User', "package.index", "package.create", "package.edit","package.delete" ]}
          />
        )
      },
      {
        path: 'pricing',
        element: <OTTPackagePricing />
      },
      {
        path: 'channelMapping',
        element: (
          <ProtectedRoute
            element={<OTTPackageChannelMapping />}
            allowedRoles={['OWNER', "package_channel_mapping.index", "package_channel_mapping.create", "package_channel_mapping.edit","package_channel_mapping.delete" ]}
          />
        )
      }
    ]
  },
  {
    path: 'ottVideoOnDemand',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="ottVod" replace />
      },
      {
        path: 'ottVod',
        element: (
          <ProtectedRoute
            element={<OTTVODListing />}
            allowedRoles={['OWNER', 'User', "vod.index", "vod.create", "vod.edit","vod.delete" ]}
          />
        )
      }
    ]
  },
  {
    path: 'ottAudioOnDemand',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="ottAudio" replace />
      },
      {
        path: 'ottAudio',
        element: (
          <ProtectedRoute
            element={<OTTAudioListing />}
            allowedRoles={['OWNER', 'User']}
          />
        )
      }
    ]
  },
  {
    path: "/forbidden",
    element: <Forbidden />,
  },

  
  {
    path: 'Advertisement',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Advertisement" replace />
      },
      {
        path: 'Advertisement',
        element: (
          <ProtectedRoute
            element={<Advertisement />}
            allowedRoles={['OWNER',"advertisement.index", "advertisement.create", "advertisement.edit", "advertisement.delete"]}
          />
        )
      }
    ]
  }
  ,
  {
    path: 'CommissionTranctions',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="CommissionTranctions" replace />
      },
      {
        path: 'CommissionWalletTransactions',
        element: (
          <ProtectedRoute
            element={<CommissionWalletTransactions />}
            allowedRoles={['OWNER',"DISTRIBUTOR","LCO","CommissionWalletTransactions.index"]}
          />
        )
      }
    ]
  }
  ,


  {
    path: 'FranchiseLocations',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="FranchiseLocations" replace />
      },
      {
        path: 'FranchiseLocations',
        element: (
          <ProtectedRoute
            element={<FranchiseLocations />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  
  
  ,

  {
    path: 'ottstatistics',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Statistics" replace />
      },
      {
        path: 'Statistics',
        element: <OTTStatistics />
      }
    ]
  },



  {
    path: 'areapricelist',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="AreaPriceList" replace />
      },
      /* {
        path: 'AreaPriceList',
         element: (
          <ProtectedRoute
            element={<AreaPriceList />}
            allowedRoles={[
              'OWNER'
            ]}
          />
        ) 
      } */
     {
      path:'AreaPriceList',
      element:<AreaPriceList />
     }
     
        ,
      
      {
        path: 'AddAreaPriceList',
        element: (
          <ProtectedRoute
            element={<AddPriceList />}
            allowedRoles={['OWNER']}
          />
        )
      },
      {
        path: 'UpdateAreaPrice/:id',
        element: (
          <ProtectedRoute
            element={<UpdateAreaPrice />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  

  {
    path: 'ottstatistics',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Maps" replace />
      },
      {
        path: 'Maps',
        element: <Maps />
      },

      {
        path: '',
        element: <Navigate to="platforms" replace />
      },
      {
        path: 'platforms',
        element: <Platforms />
      }
    ]
  },
  
  {
    path: 'ottsubscriptions',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="usersubscriptions" replace />
      },
      {
        path: 'usersubscriptions',
        element: (
          <ProtectedRoute
            element={<OTTSubscritions />}
            allowedRoles={[
              'OWNER', 
              "user_subscription.index", 
              "user_subscription.create", 
              "user_subscription.edit", 
              "user_subscription.delete"
            ]}
          />
        )
      },
      {
        path: 'usersubscriptions/:Dashsubstatus',
        element: (
          <ProtectedRoute
            element={<OTTSubscritions />}
            allowedRoles={[
              'OWNER', 
              "user_subscription.index", 
              "user_subscription.create", 
              "user_subscription.edit", 
              "user_subscription.delete"
            ]}
          />
        )
      }
    ]
  },

  

  {
    path: 'Payments',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Payments" replace />
      },
      {
        path: 'Payments',
        element: (
          <ProtectedRoute
            element={<Payments />}
            allowedRoles={['OWNER', "payment.index" ]}
          />
        )
      }
    ]
  },

  {
    path: 'vendors',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="venders" replace />
      },
      {
        path: 'vendorDetails',
        element: (
          <ProtectedRoute
            element={<VendorDetails />}
            allowedRoles={['OWNER']}
          />
        )
      },
      {
        path: 'Addvendor',
        element: (
          <ProtectedRoute
            element={<Addvendor />}
            allowedRoles={['OWNER']}
          />
        )
      },
      {
        path: 'Updatevendor/:id',
        element: (
          <ProtectedRoute
            element={<Updatevendor />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  {
    path: 'ApplicationConfig',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="channels" replace />
      },
      {
        path: 'ApplicationConfig',
        element:(
          <ProtectedRoute
            element={ <ApplicationConfig />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  {
    path: 'OTA',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="OTA" replace />
      },
      {
        path: 'OTASCREEN',
        element:(
          <ProtectedRoute
            element={ <OTASCREEN />}
            allowedRoles={['OWNER']}
          />
        )
      },
      {
        path: 'CreateOTA',
        element:(
          <ProtectedRoute
            element={ <CreateOTA />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },

  {
    path: 'Roles',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="dashboard" replace />
      },
      {
        path: 'Dashboard',
        element: <OTTDashboard />
      }
    ]
  },

  

  {
    path: 'OTT-Reconciliation',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Reconciliation" replace />
      },
      {
        path: 'Stb_Reconciliation',
        element: (
          <ProtectedRoute
            element={<Stb_Reconciliation />}
            allowedRoles={[
              'OWNER', 
              "reconciliation.index",
              "reconciliation.create",
              "reconciliation.edit",
              "reconciliation.delete"
            ]}
          />
        )
      },
      {
        path: 'Package_Channel_Reconciliation',
        element: (
          <ProtectedRoute
            element={<Package_Channel_Reconciliation />}
            allowedRoles={[
              'OWNER', 
              "reconciliation.index",
              "reconciliation.create",
              "reconciliation.edit",
              "reconciliation.delete"
            ]}
          />
        )
      },
      {
        path: 'Create_Reconciliation',
        element: (
          <ProtectedRoute
            element={<Create_Reconciliation />}
            allowedRoles={[
              'OWNER', 
              "reconciliation.index",
              "reconciliation.create",
              "reconciliation.edit",
              "reconciliation.delete"
            ]}
          />
        )
      },
      {
        path: 'Package_Channel_Reconciliation_Data/:reconcileCode',
         element: (
          <ProtectedRoute
            element={<Package_Channel_Reconciliation_Data />}
            allowedRoles={[
              'OWNER', 
              "reconciliation.index",
              "reconciliation.create",
              "reconciliation.edit",
              "reconciliation.delete"
            ]}
          />
        )
      },
      {
        path: 'Stb_Reconciliation_Data/:reconcileCode',
         element: (
          <ProtectedRoute
            element={<Stb_Reconciliation_Data />}
            allowedRoles={[
              'OWNER', 
              "reconciliation.index",
              "reconciliation.create",
              "reconciliation.edit",
              "reconciliation.delete"
            ]}
          />
        )
      }
    ]
  },

  {
    path: 'ottfingerprint',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="fingerprint" replace />
      },
      {
        path: 'fingerprint',
        element: (
          <ProtectedRoute
            element={<OTTFingerprint />}
            allowedRoles={[
              'OWNER', 
              "fingerprint.index",
              "fingerprint.create",
              "fingerprint.edit",
              "fingerprint.delete"
            ]}
          />
        )
      },
     {
      path: 'global-fingerprint',
      element: (
          <ProtectedRoute
            element={<OTTFingerprintGlobalFingerprint />}
            allowedRoles={[
              'OWNER', 
              "fingerprint.index",
              "fingerprint.create",
              "fingerprint.edit",
              "fingerprint.delete"
            ]}
          />
        )
    },
     {
      path: 'channel-fingerprint',
      element: (
          <ProtectedRoute
            element={<OTTFingerprintChannelFingerprint />}
            allowedRoles={[
              'OWNER', 
              "fingerprint.index",
              "fingerprint.create",
              "fingerprint.edit",
              "fingerprint.delete"
            ]}
          />
        )
    },
     {
      path: 'forensicFingerprintScreen',
      element: (
          <ProtectedRoute
            element={<OTTForensicFingerprintScreen />}
            allowedRoles={[
              'OWNER', 
              "fingerprint.index",
              "fingerprint.create",
              "fingerprint.edit",
              "fingerprint.delete"
            ]}
          />
        )
    },
    {
      path: 'fingerprints',
      element: (
          <ProtectedRoute
            element={<Fingerprints />}
            allowedRoles={[
              'OWNER', 
              "fingerprint.index",
              "fingerprint.create",
              "fingerprint.edit",
              "fingerprint.delete"
            ]}
          />
        )
    }
  ]
},

  {
    path: 'ottemail',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="email" replace />
      },
      {
        path: 'email',
        element: <OTTEmail />
      }
    ]
  },
  {
    path: 'ottpayments',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="payments" replace />
      },
      {
        path: 'payments',
        element: (
          <ProtectedRoute
            element={<OTTPayments />}
            allowedRoles={['OWNER',"payment.index" ]}
          />
        )
      },
      // {
      //   path: 'payments/add-franchise',
      //   element: <AddFranchisePayment fetchData={undefined} handleCloseDialog={undefined} />
      // }
    ]
  },
   {
  path: 'ottfranchisepayments',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: <Navigate to="payments" replace />
    },
    {
      path: 'payments',
      element: (
        <ProtectedRoute
          element={<OTTFranchisePayments />}
          allowedRoles={['OWNER', 'DISTRIBUTOR']}
        />
      )
    }
    ,
    {
      path: 'payments/add-franchisePayment',
      element: (
        <ProtectedRoute
          element={
            <AddFranchisePayment
              fetchData={undefined}
              handleCloseDialog={undefined}
            />
          }
          allowedRoles={['OWNER']}
        />
      )
    },
    {
      path: 'payments/add-online-franchisePayment',
      element: (
        <ProtectedRoute
          element={
            <AddOnlineFranchisePayment
              fetchData={undefined}
              handleCloseDialog={undefined}
            />
          }
          allowedRoles={['OWNER', 'DISTRIBUTOR']}
        />
      )
    }
  ]
},
    {
      path: 'payments/:paymentType/success',
      element: <PaymentSuccess />
      // element: (
      //   <ProtectedRoute
      //     element={<PaymentSuccess />}
      //     allowedRoles={['OWNER', 'payment.index']}
      //   />
      // )
    },

    
    {
      path: 'PaymentFailure',
      element: (
        <ProtectedRoute
          element={<PaymentFailed />}
          allowedRoles={['OWNER', 'payment.index']}
        />
      )
    },

  
  {
    path: 'ottUserPanle',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="userpanel" replace />
      },
      {
        path: 'userpanel',
        element: (
          <ProtectedRoute
            element={<OTTUserPanel />}
            allowedRoles={['OWNER', "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete" ]}
          />
        )
      },
      {
        path: 'multiplesubscriptions',
        element: (
          <ProtectedRoute
            element={<Multiplesubscriptions/>}
            allowedRoles={['OWNER', "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete" ]}
          />
        )
      },
      {
        path: 'userpanel/:dashuser',
        element: (
          <ProtectedRoute
            element={<OTTUserPanel />}
            allowedRoles={['OWNER', "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete" ]}
          />
        )
      }

    ]
  },

 

  {
    path: 'franchise',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="franchise" replace />
      },
      {
        path: 'franchise',
        element: (
          <ProtectedRoute
            element={<Franchise />}
            allowedRoles={['OWNER', "franchise.index", "franchise.create", "franchise.edit","franchise.delete" ]}
          />
        )
      }
      ,
      {
        path: 'addfranchise',
        element: (
          <ProtectedRoute
            element={<AddFranchisee />}
            allowedRoles={['OWNER', "franchise.create", "franchise.edit"]}
          />
        )
      },
      {
        path: 'EditFranchisee/:id',
        element: (
          <ProtectedRoute
            element={<EditFranchisee />}
            allowedRoles={['OWNER', "franchise.edit"]}
          />
        )
      }
      
    ]
  },

  {
    path: 'Company',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="company" replace />
      },
      {
        path: 'Company',
        element : (
        <ProtectedRoute
        element={<CompanyScreen />}
         allowedRoles={['OWNER', "company.index", "company.create", "company.edit","company.delete" ]}
        />
      )
      },
      {
        path: 'AddCompany',
        element : (
        <ProtectedRoute
        element={<AddCompany/>}
         allowedRoles={['OWNER', "company.create"]}
        />
      )
      },
      {
        path: 'Updatecompany/:id',
        element : (
        <ProtectedRoute
        element={<Updatecompany/>}
         allowedRoles={['OWNER', "company.edit"]}
        />
      )
      }
    ]
  },

  {
    path: 'Operator',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="operator" replace />
      },
      {
        path: 'operator',
        element: (
          <ProtectedRoute
            element={<OperatorScreen />}
            allowedRoles={['OWNER', "operator.index", "operator.create", "operator.edit","operator.delete" ]}
          />
        )
      },
      {
      path: 'addoperator',
      element: <AddOperator onClose={function (): void {
        throw new Error('Function not implemented.');
      } } onSuccess={function (): void {
        throw new Error('Function not implemented.');
      } } />
    },
     {
      path: 'editoperator/:id', 
      element: (
        <EditOperator
          onClose={() => { } }
          onSuccess={() => { } } operatorId={''}        />
      )
    }
    ]
  },

  {
    path: 'schedules',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="schedules" replace />
      },
      {
        path: 'schedules',
        element: (
          <ProtectedRoute
            element={<Schedules />}
            allowedRoles={['OWNER', "schedule.index",  ]}
          />
        )
      }
    ]
  },


  {
    path: 'CustomerTickets',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="schedules" replace />
      },
      {
        path: 'SubscriberTickets',
        element: (
          <ProtectedRoute
            element={<SubscribersTickets />}
            allowedRoles={['OWNER']}
          />
        )
      }
    ]
  },
  
  /* watcho */
  {
    path: 'ottwatcho',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="schedules" replace />
      },
      {
        path: 'watcho',
        element: (
          <ProtectedRoute
            element={<Watcho/>}
            allowedRoles={['OWNER',  ]}
          />
        )
      },
      {
        path: 'watchoDetails/:id',
        element: (
          <ProtectedRoute
            element={<WatchoDetails/>}
            allowedRoles={['OWNER',  ]}
          />
        )
      }
    ]
  },
  {
    path: 'ottContentPanle',
    element: <SidebarLayout />,
    children: [
      { path: '', element: <Navigate to="category" replace /> },
     { path: 'category', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', "category.index", "category.create", "category.delete"]}
      />
    ) },
     { path: 'broadcaster', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "broadcaster.index", "broadcaster.create", "broadcaster.edit","broadcaster.delete"]}
      />
    ) },
     { path: 'channel-setup', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', "channel.index", "channel.create", "channel.edit","channel.delete"]}
      />
    ) },
     { path: 'vod', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "vod.index", "vod.create", "vod.edit","vod.delete"]}
      />
    ) },
     { path: 'package', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "package.index", "package.create", "package.edit","package.delete"]}
      />
    ) },
     { path: 'package-mapping', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "package_channel_mapping.index", "package_channel_mapping.create"]}
      />
    ) },
     { path: 'app', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "app.index", "app.create", "app.edit","app.delete"]}
      />
    ) },
     { path: 'youtube', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "youtube.index", "youtube.create", "youtube.edit","youtube.delete"]}
      />
    ) },
     { path: 'epg', element: (
      <ProtectedRoute
        element={<OTTContentPanel />}
        allowedRoles={['OWNER', 'User', "epg.index", "epg.upload"]}
      />
    ) }
   ]
  },

  {
    path: 'ottserverspanel',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="servers" replace />
      },
      {
        path: 'Servers',
         element: (
          <ProtectedRoute
            element={<Servers />}
            allowedRoles={['OWNER',"servers.index", "servers.create", "servers.edit","servers.delete" ]}
          />
        )
      },
     /*  {
        path: 'servers',
        element: (
          <ProtectedRoute
            element={<OTTServersPanel />}
            allowedRoles={['OWNER', "server.index", "server.create", "server.edit", "server.delete" ]}
          />
        ),
        children: [
          {
            path: '',
            element: <Navigate to="physical" replace />
          },
          {
            path: 'physical',
            element: null
          },
          {
            path: 'customer',
            element: null
          }
        ]
      } */
    ]
  },

  {
    path: 'Role',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="Role" replace />
      },
      {
        path: 'role',
         element: (
          <ProtectedRoute
            element={<Role />}
            allowedRoles={['OWNER',"roles.index", "roles.create", "roles.edit","roles.delete" ]}
          />
        )
      }
      ,
      {
        path: 'addrole',
         element: (
          <ProtectedRoute
            element={<AddRole />}
            allowedRoles={['OWNER', "roles.create" ]}
          />
        )
      }
      ,
      {
        path: 'updaterole/:id',
         element: (
          <ProtectedRoute
            element={<EditRole />}
            allowedRoles={['OWNER', "roles.edit" ]}
          />
        )
      }
      ,
      {
        path: 'menusrole/:roleId',
         element: (
          <ProtectedRoute
            element={<MenusRole />}
            allowedRoles={['OWNER', "roles.edit" ]}
          />
        )
      }/* ,
      {
        path: 'rights/:roleId/:menuId',
         element: (
          <ProtectedRoute
            element={<MenusRole />}
            allowedRoles={['OWNER', "roles.edit" ]}
          />
        )
      } */
      
    ]
  },

  // OTT Ends

  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="tasks" replace />
      },
      {
        path: 'tasks',
        element: <Tasks />
      },
      {
        path: 'messenger',
        element: <Messenger />
      }
    ]
  },
  {
    path: 'paymentTransfer',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="tasks" replace />
      },
      {
        path: 'PaymentTransfer',
        element: (
          <ProtectedRoute
            element={<PaymentTransfer />}
            allowedRoles={['OWNER', "LCO_WALLET_ACCESS","PT.index", "PT.create", "PT.edit","PT.delete" ]}
          />
        )
      },
      {
        path: 'PaymentHistoryList',
        element: (
          <ProtectedRoute
            element={<PaymentHistoryList />}
            allowedRoles={['OWNER', "LCO_WALLET_ACCESS","PaymentHistoryList.index", "PaymentHistoryList.create", "PaymentHistoryList.edit","PaymentHistoryList.delete" ]}
          />
        )
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'transactions',
        element: <Transactions />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;